module.exports = require('./helpers/bundle-url').getBundleURL('k1NDn') + "logo.c51670a8.svg";